<form [formGroup]="form">
  <div class="flex margin-top-15 f-gap--10px" formGroupName="deathsAura">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--left">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">
          DECESOS AURA
        </mat-card-title>
        <howden-label-value
          class="f-basis--2 group-result-rmbonus"
          [value]="deathsAura.productName || ''">
        </howden-label-value>
      </mat-card-header>

      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-15">
        <div class="flex f-gap--10px" style="align-items:flex-start;">

          <mat-form-field class="field-inputs f-basis--2">
            <mat-label i18n="@@app.sane-projects.edit.label">Generar Programa</mat-label>
            <mat-select
              formControlName="decAuraSelectChargeable"
              [howdenControlError]="decAuraSelectChargeableError"
              [compareWith]="compareByIdBoolean">
              @for (item of (deathsAura.getMasterValues('S_DEC_AURA_SELECT_CHARGEABLE') | howdenArraySort:'description'); track item.id) {
                <mat-option [value]="item.id">{{ item.description }}</mat-option>
              } @empty {
                <mat-option disabled>No hay opciones disponibles</mat-option>
              }
            </mat-select>
            <mat-error #decAuraSelectChargeableError></mat-error>
          </mat-form-field>

          @if (showAuraFields) {
            <mat-form-field class="field-inputs f-basis--1">
              <mat-label i18n="@@app.sane-projects.calculator.label">Asesoría fiscal</mat-label>
              <input
                matInput type="number" inputmode="decimal" min="0" step="any"
                formControlName="decAuraTaxAdvice"
                [howdenControlError]="decAuraTaxAdviceError"
                [howdenMax]="9999999" />
              <mat-error #decAuraTaxAdviceError></mat-error>
            </mat-form-field>

            <mat-form-field class="field-inputs f-basis--1">
              <mat-label i18n="@@app.sane-projects.calculator.label">Sepelio</mat-label>
              <input
                matInput type="number" inputmode="decimal" min="0" step="any"
                formControlName="decAuraBurial"
                [howdenControlError]="decAuraBurialError"
                [howdenMax]="9999999" />
              <mat-error #decAuraBurialError></mat-error>
            </mat-form-field>
          }

          @if (showTrace()) {
            <div class="f-basis--3">
              <div class="trace-container" [innerHTML]="getTraceHtml(deathsAura)"></div>
            </div>
          }

          <div class="flex f-basis--2 group-result-rmbonus" style="flex-direction:column;">
            @if (deathsAura.chargeable) {
              <howden-label-value
                labelText="Prima"
                [value]="deathsAura.bonus | bonus">
              </howden-label-value>
            } @else {
              @for (m of getMessages(deathsAura); track m.html ?? $index) {
                @if (m.blocking) {
                  <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }

            @for (m of getMessages(deathsAura); track m.html ?? $index) {
              @if (!m.blocking) {
                <br />
                <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
              }
            }
          </div>

        </div>
      </mat-card-content>
    </mat-card>
  </div>
</form>
